export const PAGE_SIZE = 50;
export const LIST_PAGE_NAME = 'PLAYERS';
export const PLAYER_STATUS_ORDERS = {
  REGISTERED: 0,
  RESET: 1,
  ACTIVE: 2,
  ARCHIVED: 3,
  DESTROYED: 4,
};
export const VIEW_DIALOG_NAME = 'PLAYER';